// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1y8mG","label":"styles_label__thR2K","input":"styles_input__Rgycv"};